import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { mywalletcard } from '../../../_services/mywallet/card/mywallet.card.service';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { carddetail } from '../../../models/mywallet/card/mywallet.card.Modal';
import { CountryDetail } from '../../../sharedcomponents/_common/countrylist/countryinformation';
import { state } from '../../../sharedcomponents/_common/countrylist/state';
import { CountryService } from '../../../sharedcomponents/commonservice/countrylist.service';
import { usercommonattribute } from '../../../_services/userservice/user.common.service';
import { AppSettings, enumStatusCodeList } from '../../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { StatelistComponent } from '../../../sharedcomponents/_common/countrylist/statelist.component';
import { CitylistComponent } from '../../../sharedcomponents/_common/countrylist/citylist.component';
import * as moment from 'moment';
import { GoogleAutocompleteComponent } from 'app/sharedcomponents/_common/countrylist/google-autocomplete/google-autocomplete.component';

export class CustomModalContext extends BSModalContext {
    public modalData: any;
}

@Component({
    selector: 'app-addcard',
    templateUrl: './addcard.component.html',
    // styleUrls: ['./addcard.component.css'],
    styles: [
        `
      .modal-dialog {
        width: 80% !important;
      }
    `
    ],
    encapsulation: ViewEncapsulation.Emulated,
    providers: [mywalletcard, AlertService, carddetail, CountryService, utilityService, Modal]
})
export class AddcardComponent implements ModalComponent<CustomModalContext>, OnInit {
    context: CustomModalContext;
    filterstates: any;
    filterCities: any;
    cityCollection: any;
    countrycollection = [];
    isaddressfromprofile = false;
    stateCollection: Array<state> = new Array<state>();
    //selectedState: any;
    appSettings;
    cardExpieryMonth = [];
    cardExpieryYear = [];
    cardImage: any = [];
    public addressSettings: any = {
        showSearchButton: false,
        geoCountryRestriction: ['us'],
        inputPlaceholderText: this.translate.instant('Common_lblSearchFromGoogle'),
        geoTypes: ['establishment', 'address', 'geocode']
    };
    constructor(
        public dialog: DialogRef<CustomModalContext>,
        private alertService: AlertService,
        private cardservice: mywalletcard,
        public cardDisplayModel: carddetail,
        private countryserv: CountryService,
        private usermodel: usercommonattribute, //For getting user detail from profile
        public utilityServ: utilityService,
        private translate: TranslateService,
        private router: Router,
        public modal: Modal
    ) {
        
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.dialog.close();
            }
        });
        this.context = dialog.context;
        this.context.size = 'lg';
    }

    ngOnInit() {

        let self = this;

        self.getcountrylistfromservice();

        let coll = self.countrycollection.filter(function (country) {
            return country.CountryCode === self.cardDisplayModel.CountryCode;
        });

        if (coll.length > 0) {
            self.stateCollection = coll[0].CountryState;
        }

        self.appSettings = AppSettings;
        // Initalize Date and Year
        self.initalizeMonthandYearDropDown();
        if (localStorage.CardImages != undefined && localStorage.CardImages != 'undefined') {
            self.cardImage = JSON.parse(localStorage.CardImages);
        }
    }
    adddebitcard() {
        //console.log("i am in debit card add");
        try {
            let store = new Map<string, string>();
            store = this.cardservice.validatecreditcard(this.cardDisplayModel.cardnumber);
            this.cardDisplayModel.PaymentType = store.get('cardtype');
            this.cardDisplayModel.CardSubType = store.get('cardsubtype');
            this.cardDisplayModel.lastfourcardnumber = this.cardDisplayModel.cardnumber.substr(-4, 4);
            //  this.cardDisplayModel.ExpirationMonth += 1; // Increase month value as in drop down it's starting from 0

            this.utilityServ.busy = this.cardservice.addcardservice(this.cardDisplayModel).subscribe(data => {
                //console.log(data);
                if (data.Envelope.Body.GetPaymentActivationCodeResponse.StatusCode == -10000) {
                    this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
                    return;
                }
                if (data.Envelope.Body.GetPaymentActivationCodeResponse.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
                    return false;
                }
                if (data.Envelope.Body.GetPaymentActivationCodeResponse.StatusCode == enumStatusCodeList.SUCCESS) {

                    // Register Card on ICE Server

                    this.utilityServ.busy = this.cardservice.registercardonice(data.Envelope.Body.GetPaymentActivationCodeResponse, this.cardDisplayModel).subscribe(
                        cardata => {
                            if (cardata.data.status == 200 || cardata.data.status == 204) {
                                // Validate ICE request a

                                this.dialog.context.modalData.next = 'yes';
                                this.closeClick();
                            } else {
                                // fail message

                                this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
                            }

                        },
                        error => {
                            // this.closeClick();
                            // //console.log(error);
                        }
                    );
                } else {

                    this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), data.Envelope.Body.GetPaymentActivationCodeResponse.StatusMessage);
                }
            });
        } catch (ex) {
            //console.log('Error at Add Card' + ex);

        }
    }
    getcountrylistfromservice() {
        this.countrycollection = this.countryserv.getCountryListFromLocale();
        this.cardDisplayModel.CountryCode = AppSettings.BaseCountry;

        // if (this.cardDisplayModel.CountryCode != '') {
        //   this.filterstates = this.countrycollection.filter(item => item.CountryCode == this.cardDisplayModel.CountryCode)[0].states;
        // }
        // if (this.cardDisplayModel.StateCode != '') {
        //   try {
        //     this.cityCollection = this.filterstates.filter(item => item.statecode == this.cardDisplayModel.StateCode)[0].CityList;
        //   } catch (ex) {
        //     this.cityCollection = null;
        //   }
        // }
    }

    onStateChanged(event) {

        let self = this;

        if (self.cardDisplayModel.StateCode) {

            let selectedState = self.stateCollection.find(x => {
                return x.statecode == self.cardDisplayModel.StateCode;
            });

            if (selectedState) {
                self.cardDisplayModel.StateName = selectedState.name;
            }

        } else {
            self.cardDisplayModel.StateName = '';
        }        
    }

    openStateBox() {
        let self = this;
        let modalData: any = {};
        modalData.CountryCode = this.cardDisplayModel.CountryCode;
        modalData.StateCollection = this.filterstates;
        return this.modal.open(StatelistComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
            obj.onDestroy.subscribe(data => {
                if (modalData.next.StateCode == undefined) {
                } else {
                    self.cardDisplayModel.StateCode = modalData.next.StateCode;
                    self.ddlStateOnChange(modalData.next.StateCode);
                }
            });
        });
    }

    openCityBox() {
        let self = this;
        let modalData: any = {};
        modalData.CountryCode = this.cardDisplayModel.CountryCode;
        modalData.StateCode = this.cardDisplayModel.StateCode;
        modalData.CityCollection = this.cityCollection;
        return this.modal.open(CitylistComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
            obj.onDestroy.subscribe(data => {
                if (modalData.next.City == undefined) {
                } else {
                    self.cardDisplayModel.City = modalData.next.City;
                    // self.searchForBranch();
                }
            });
        });
    }

    openCityBoxEx() {
        let self = this;
        let modalData: any = {};
        let citySettings = {
            showSearchButton: false,
            geoTypes: ['(cities)'],
            geoCountryRestriction: ['us'],
            inputPlaceholderText: this.translate.instant('Common_lblSearchFromGoogle')
        };
        modalData.userSettings = citySettings;
        return this.modal.open(GoogleAutocompleteComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
            obj.onDestroy.subscribe(data => {
                if (modalData.addressData == undefined) {
                } else {
                    // self.model.city = modalData.next.City;
                    let addressData = modalData.addressData;
                    self.cardDisplayModel.City = self.utilityServ.getObjectText(addressData.city);
                    self.cardDisplayModel.StateCode = self.utilityServ.getObjectText(addressData.stateCode);
                    self.cardDisplayModel.StateName = self.utilityServ.getObjectText(addressData.stateName);
                    self.cardDisplayModel.PostalCode = self.utilityServ.getObjectText(addressData.zipcode);
                    // self.searchForBranch();
                }
            });
        });
    }

    ddlStateOnChange(stateCode) {
        if (stateCode == '') {
            this.cityCollection = [];
            return;
        }
        this.cardDisplayModel.City = '';
        this.cityCollection = this.filterstates.filter(function (state) {
            return state.StateCode === stateCode;
        })[0].CityList;
        if (this.cityCollection != null) {
            // this.cardDisplayModel.City = this.cityCollection[0];
        }
    }

    // onStateChange(stateCode) {
    //   // this.cityCollection = this.filterstates.filter(item => item.StateCode == this.cardDisplayModel.StateCode)[0].Cities;
    //   this.cityCollection = this.filterstates.filter(item => item.StateCode == this.cardDisplayModel.StateCode)[0].CityList;
    // }
    getuserprofiledetail(evt) {
        this.isaddressfromprofile = evt;
        if (this.isaddressfromprofile) {
            this.cardDisplayModel.Address = this.usermodel.address;
            this.cardDisplayModel.PostalCode = this.usermodel.zipcode;
            this.cardDisplayModel.City = this.usermodel.city;
            this.cardDisplayModel.StateCode = this.usermodel.state;
            this.cardDisplayModel.StateName = this.usermodel.stateName;
            this.cardDisplayModel.CountryCode = this.usermodel.country;
            // this.filterstates = this.countrycollection.filter(item => item.CountryCode == this.cardDisplayModel.CountryCode)[0].states;
            // this.cityCollection = this.filterstates.filter(item => item.StateCode == this.cardDisplayModel.StateCode)[0].CityList;
        } else {
            this.cardDisplayModel.Address = '';
            this.cardDisplayModel.PostalCode = '';
            this.cardDisplayModel.City = '';
            this.cardDisplayModel.StateCode = '';
            this.cardDisplayModel.StateName = '';
        }
    }
    closeClick() {
        this.dialog.close();
    }
    initalizeMonthandYearDropDown() {
        const year = new Date().getFullYear();

        // var range = [];
        this.cardExpieryYear.push(year);
        for (let i = 1; i < 50; i++) {
            this.cardExpieryYear.push(year + i);
        }
        for (let i = 1; i <= 12; i++) {
            this.cardExpieryMonth.push(i);
        }
    }
    fillExpireMonth() {
        const year = new Date().getFullYear();
        const curMonth = moment()
            .month(moment().format('MMMM'))
            .format('M');
        if (this.cardDisplayModel.ExpirationYear == year) {
            // If year is current year
            const currMonthName = moment().format('M');
            this.cardExpieryMonth = this.cardExpieryMonth.filter(data => data >= curMonth);
        } else {
            let tempCardExpieryMonth: any = [];
            for (let i = 1; i <= 12; i++) {
                tempCardExpieryMonth.push(i);
            }
            this.cardExpieryMonth = tempCardExpieryMonth;
        }
    }
    autoCompleteCallback(place: any) {
        let addressData: any = {};
        let componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'short_name',
            country: 'long_name',
            postal_code: 'short_name'
        };
        if (place.data == undefined) {
            return false;
        }
        let data = place.data.address_components;
        for (var i = 0; i < data.length; i++) {
            var addressType = data[i].types[0];
            if (componentForm[addressType]) {
                switch (addressType) {
                    case 'street_number':
                        addressData.address1 = data[i].long_name;
                        break;
                    case 'route':
                        addressData.address2 = data[i].long_name;
                        break;
                    case 'locality':
                        addressData.city = data[i].long_name;
                        break;
                    case 'administrative_area_level_1':
                        addressData.stateName = data[i].long_name;
                        addressData.stateCode = data[i].short_name;
                        break;
                    case 'country':
                        addressData.countryCode = data[i].short_name;
                        addressData.countryName = data[i].long_name;
                        break;
                    case 'postal_code':
                        addressData.zipcode = data[i].long_name;
                        break;
                    default:
                        break;
                }
            }
        }
        // this.utilityServ.getObjectText(place.data.name) + ', ' +
        this.cardDisplayModel.Address =
            this.utilityServ.getObjectText(addressData.address1) + ' ' + this.utilityServ.getObjectText(addressData.address2);
        this.cardDisplayModel.City = this.utilityServ.getObjectText(addressData.city);
        this.cardDisplayModel.StateCode = this.utilityServ.getObjectText(addressData.stateCode);
        this.cardDisplayModel.StateName = this.utilityServ.getObjectText(addressData.stateName);
        this.cardDisplayModel.PostalCode = this.utilityServ.getObjectText(addressData.zipcode);
    }

    openAddressBox() {
        let self = this;
        let modalData: any = {};
        let addressSettings: any = {
            showSearchButton: false,
            geoCountryRestriction: ['us'],
            inputPlaceholderText: this.translate.instant('Common_lblSearchFromGoogle'),
            geoTypes: ['establishment', 'address', 'geocode']
        };
        modalData.userSettings = addressSettings;
        return this.modal.open(GoogleAutocompleteComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
            obj.onDestroy.subscribe(data => {
                if (modalData.addressData == undefined) {
                } else {
                    let addressData = modalData.addressData;
                    self.cardDisplayModel.Address = self.utilityServ.getObjectText(addressData.address1) + ' ' + self.utilityServ.getObjectText(addressData.address2);
                    self.cardDisplayModel.City = self.utilityServ.getObjectText(addressData.city);
                    self.cardDisplayModel.StateCode = self.utilityServ.getObjectText(addressData.stateCode);
                    self.cardDisplayModel.StateName = self.utilityServ.getObjectText(addressData.stateName);
                    self.cardDisplayModel.PostalCode = self.utilityServ.getObjectText(addressData.zipcode) != '' ? self.utilityServ.getObjectText(addressData.zipcode) : self.cardDisplayModel.PostalCode;
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/mywallet/card/addcard/addcard.component.ts